import React, { useEffect, useState } from "react";
import "../Pages/card.scss";
import Card from "../Components/Card";
import { TagButton, TagButtonAll } from "../Components/TagButtons";
import kitchen from "../assets/Ostrog/1_fl/003.jpg";
import ladder from "../assets/Ostrog/2_fl/002.jpg";
import hall from "../assets/Ostrog/1_fl/005.jpg";
import hallway from "../assets/Ostrog/1_fl/011.jpg";
import guestroom from "../assets/Ostrog/1_fl/015.jpg";
import bathroom from "../assets/Ostrog/1_fl/017.jpg";
import bathroom_2 from "../assets/Ostrog/1_fl/021.jpg";
import livingroom from "../assets/Ostrog/2_fl/014.jpg";
import bedroom from "../assets/Ostrog/2_fl/010.jpg";
import wardrobe from "../assets/Ostrog/2_fl/011.jpg";
import bathroom_3 from "../assets/Ostrog/2_fl/004.jpg";
import measurementplan from "../assets/Ostrog/plans/163852.jpg";
import plan from "../assets/Ostrog/plans/164146.jpg";
import plans from "../assets/Ostrog/plans/164204.jpg";
import wallplans from "../assets/Ostrog/plans/171915.jpg";
import specification from "../assets/Ostrog/plans/172034.jpg";
import flat from "./data.json";
import { useCallback } from "react";
import Gallery from "../Components/GalleryViewer";
import { Translation } from "react-i18next";

const images = flat;

const apartmentCardsData = [
  {
    img: kitchen,
    alt: "kitchen",
    titleKey: "portfolio.title-1",
    descKey: "portfolio.description",
    tagName: "кухня",
  },
  {
    img: hall,
    alt: "hall",
    titleKey: "portfolio.title-17",
    descKey: "portfolio.description-17",
    tagName: "холл",
  },
  {
    img: ladder,
    alt: "ladder",
    titleKey: "portfolio.title-18",
    descKey: "portfolio.description-18",
    tagName: "лестница",
  },
  {
    img: hallway,
    alt: "hallway",
    titleKey: "portfolio.title-8",
    descKey: "portfolio.description-8",
    tagName: "прихожая",
  },
  {
    img: guestroom,
    alt: "guestroom",
    titleKey: "portfolio.title-19",
    descKey: "portfolio.description-19",
    tagName: "гостевая",
  },
  {
    img: bathroom,
    alt: "bathroom",
    titleKey: "portfolio.title-6",
    descKey: "portfolio.description-6",
    tagName: "ванная",
  },
  {
    img: bathroom_2,
    alt: "bathroom_2",
    titleKey: "portfolio.title-20",
    descKey: "portfolio.description-20",
    tagName: "санузел",
  },
  {
    img: livingroom,
    alt: "livingroom",
    titleKey: "portfolio.title-2",
    descKey: "portfolio.description-2",
    tagName: "гостиная",
  },
  {
    img: bedroom,
    alt: "bedroom",
    titleKey: "portfolio.title-3",
    descKey: "portfolio.description-3",
    tagName: "спальня",
  },
  {
    img: wardrobe,
    alt: "wardrobe",
    titleKey: "portfolio.title-7",
    descKey: "portfolio.description-7",
    tagName: "гардеробная",
  },
  {
    img: bathroom_3,
    alt: "bathroom_3",
    titleKey: "portfolio.title-6",
    descKey: "portfolio.description-6",
    tagName: "ванная-2",
  },
  {
    img: measurementplan,
    alt: "measurementplan",
    titleKey: "portfolio.title-16",
    descKey: "portfolio.description-16",
    tagName: "обмерный план",
  },
  {
    img: plan,
    alt: "plan",
    titleKey: "portfolio.title-11",
    descKey: "portfolio.description-11",
    tagName: "планировка",
  },
  {
    img: plans,
    alt: "plans",
    titleKey: "portfolio.title-13",
    descKey: "portfolio.description-13",
    tagName: "планы",
  },
  {
    img: wallplans,
    alt: "wallplans",
    titleKey: "portfolio.title-14",
    descKey: "portfolio.description-14",
    tagName: "развёртки",
  },
  {
    img: specification,
    alt: "specification",
    titleKey: "portfolio.title-15",
    descKey: "portfolio.description-15",
    tagName: "спецификация",
  },
];

function FlatSix() {
  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  useEffect(() => {
    tag === "all"
      ? setFilteredImages(images.flat_6)
      : setFilteredImages(images.flat_6.filter((image) => image.tag === tag));
  }, [tag]);

  useEffect(() => {
    if (isViewerOpen) {
      document.body.classList.add("viewer-open");
    } else {
      document.body.classList.remove("viewer-open");
    }
  }, [isViewerOpen]);

  return (
    <Translation>
      {(t) => (
        <div
          style={{
            fontWeight: "bold",
            fontFamily: "Montserrat, sans-serif",
            textAlign: "center",
            color: "#46669c",
          }}
        >
          <h5
            style={{ fontWeight: "600", marginLeft: "1em", marginRight: "1em" }}
          >
            {t(["portfolio.adres-6"])}
            {/*  Interior design project of the house. Ukraine. Ostrog. 1st & 2nd floors */}
          </h5>
          <div className="wrapper mt-4">
            {apartmentCardsData.map((card, index) => (
              <div
                className="card"
                key={index}
                style={{ fontFamily: "Montserrat, sans-serif" }}
              >
                <Card
                  img={card.img}
                  alt={card.alt}
                  title={t([card.titleKey])}
                  description={t([card.descKey])}
                />
                <div onClick={() => openImageViewer(0)}>
                  <TagButton
                    name={card.tagName}
                    tagactive={tag === card.tagName}
                    handleSetTag={setTag}
                  />
                </div>
              </div>
            ))}
          </div>

          <div onClick={() => openImageViewer(0)}>
            <TagButtonAll
              name="all"
              tagactive={tag === "all" ? true : false}
              handleSetTag={setTag}
            />
          </div>

          <div>
            {isViewerOpen && (
              <Gallery
                images={filteredImages}
                startIndex={currentImage}
                onClose={closeImageViewer}
              />
            )}
          </div>
        </div>
      )}
    </Translation>
  );
}

export default FlatSix;
